import React, { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { TextInput, SelectItem, TextArea, Checkbox } from '../../../assets/Form'
import { Paragraph, Text, Tip } from '../../../assets/Text'
import { Alert } from '../../../assets/UIElements'
import { Button } from '../../../assets/Buttons'
import AVH from '../../../helpers/AuthValidateHelper'
import UserProfileHelper from '../../../helpers/UserProfileHelper'
import GH from '../../../helpers/GeneralHelper'
import matchConfig from '../../../config/matchConfig'
import '../../../scss/signup.scss'

// import GetImg from '../../../assets/GetImg'

const Register = props => {

  const relationshipArr = matchConfig.form["relationshipArr" + props.selectedLang]
  const gender = matchConfig.form["genderArr" + props.selectedLang]
  const states = matchConfig.form["states" + props.selectedLang]

  const livingSituationArr = matchConfig.form["livingSituation" + props.selectedLang]
  const studyFieldArr = matchConfig.form["studyField" + props.selectedLang]
  const problemCategoryArr1 = matchConfig.form["problemCategory" + props.selectedLang]
  const problemCategoryArr2 = matchConfig.form["problemCategory" + props.selectedLang]
  const problemCategoryArr3 = matchConfig.form["problemCategory" + props.selectedLang]
  const copingStrategyArr1 = matchConfig.form["copingStrategy" + props.selectedLang]
  const copingStrategyArr2 = matchConfig.form["copingStrategy" + props.selectedLang]
  const copingStrategyArr3 = matchConfig.form["copingStrategy" + props.selectedLang]
  const [hidePass, changeHide] = useState(true)
  const [email, updateEmail] = useState('')
  const [name, updateName] = useState('')
  const [password, updatePassword] = useState('')
  const [birthYear, updateBirthYear] = useState(null)
  const [deceased, updateDeceased] = useState(relationshipArr[0]['value'])
  const [studyField, updatestudyField] = useState(studyFieldArr[0]['value'])
  const [livingSituation, updateLivingSituation] = useState(livingSituationArr[0]['value'])
  const [problemCategory1, updateProblemCategory1] = useState(problemCategoryArr1[0]['value'])
  const [problemCategory2, updateProblemCategory2] = useState(problemCategoryArr2[0]['value'])
  const [problemCategory3, updateProblemCategory3] = useState(problemCategoryArr3[0]['value'])
  const [copingStrategy1, updateCopingStrategy1] = useState(copingStrategyArr1[0]['value'])
  const [copingStrategy2, updateCopingStrategy2] = useState(copingStrategyArr2[0]['value'])
  const [copingStrategy3, updateCopingStrategy3] = useState(copingStrategyArr3[0]['value'])
  const [sex, updateSex] = useState(gender[0]['value'])
  const [location, updateLocation] = useState(states[0]['value'])
  const [story, updateStory] = useState('')
  const [hobby, updateHobby] = useState('')
  const [disclaimer, checkDisclaimer] = useState(false)

  //validate password input
  const [passValidated, updatePassValidated] = useState(true)
  const [lowercase, updateLowercase] = useState(false)
  const [capital, updateCapital] = useState(false)
  const [number, updateNumber] = useState(false)
  const [special, updateSpecial] = useState(false)
  const [minimum, updateMinimum] = useState(false)

  //validate submitted content
  const [emailValidated, updateEmailValidated] = useState('')
  const [passError, updatePassError] = useState('')
  const [nameError, updateNameError] = useState('')
  const [birthError, updateBirthError] = useState('')
  const [studyFieldError, updatestudyFieldError] = useState('')
  const [livingSituationError, updatelivingSituationFieldError] = useState('')

  const [problemCategoryError1, updateproblemCategoryError1] = useState('')
  const [problemCategoryError2, updateproblemCategoryError2] = useState('')
  const [problemCategoryError3, updateproblemCategoryError3] = useState('')
  const [copingStrategyError1, updatecopingStrategyError1] = useState('')
  const [copingStrategyError2, updatecopingStrategyError2] = useState('')
  const [copingStrategyError3, updatecopingStrategyError3] = useState('')
  
  const [deceasedError, updateDeceasedError] = useState('')
  const [sexError, updateSexError] = useState('')
  const [locationError, updateLocationError] = useState('')
  const [storyError, updateStoryError] = useState('')
  const [hobbyError, updateHobbyError] = useState('')
  const [disclaimerError, updateDisclaimerError] = useState('')

  //register error
  const [registerError, updateRegisterError] = useState('')
  const [registerSuccessful, updateSuccess] = useState(false)

  // use React hook to add event listener for enter event.
  // useEffect(() => {
  //   if(document.getElementById('match-register-form') !== null)
  //   {
  //     document.getElementById('match-register-form').addEventListener('keydown', handleSubmit)
  //   }

  //   return () => {
  //     if(document.getElementById('match-register-form') !== null && document.getElementById('match-register-form').removeEventListener === 'function')
  //     {
  //       document.getElementById('match-register-form').addEventListener('keydown', handleSubmit)
  //     }
  //   }
  // })

  const registerFunction = async () => {
    const emailValid = await AVH.validateEmail(email)
    if (!emailValid) updateEmailValidated(props.lang.registerValid.email)
    if (name === '') updateNameError(props.lang.registerValid.displayname)
    if (password === '' || !passValidated) updatePassError(props.lang.registerValid.password)
    if (birthYear === null) updateBirthError(props.lang.registerValid.birthyear)
    //if(deceased === '' || deceased === '0') updateDeceasedError(props.lang.registerValid.relationship)
    if (sex === '' || sex === '0') updateSexError(props.lang.registerValid.gender)
    if (location === '' || location === '0') updateLocationError(props.lang.registerValid.location)
    if (studyField === '' || studyField === '0') updatestudyFieldError(props.lang.registerValid.studyField)
    if (livingSituation === '' || livingSituation === '0') updatelivingSituationFieldError(props.lang.registerValid.livingsituation)

    if (problemCategory1 === '' || problemCategory1 === '0') updateproblemCategoryError1(props.lang.registerValid.problemCategory)
    if (problemCategory2 === '' || problemCategory2 === '0') updateproblemCategoryError2(props.lang.registerValid.problemCategory)
    if (problemCategory3 === '' || problemCategory3 === '0') updateproblemCategoryError3(props.lang.registerValid.problemCategory)
    if (copingStrategy1 === '' || copingStrategy1 === '0') updatecopingStrategyError1(props.lang.registerValid.copingStrategy)
    if (copingStrategy2 === '' || copingStrategy2 === '0') updatecopingStrategyError2(props.lang.registerValid.copingStrategy)
    if (copingStrategy3 === '' || copingStrategy3 === '0') updatecopingStrategyError3(props.lang.registerValid.copingStrategy)

    if (story === '') updateStoryError(props.lang.registerValid.required)
    if (hobby === '') updateHobbyError(props.lang.registerValid.required)
    if (!disclaimer) updateDisclaimerError(props.lang.registerValid.disclaimer)

    if (emailValid && name !== '' && password !== ''
      && birthYear !== null
      //&& deceased !== '' && deceased !== '0'
      && sex !== '' && sex !== '0'
      && location !== '' && location !== '0' && story !== '' && disclaimer && hobby !== ''
      && studyField !== '' && studyField !== '0'
      && livingSituation !== '' && livingSituation !== '0'
      && problemCategory1 !== '' && problemCategory1 !== '0'
      && copingStrategy1 !== '' && copingStrategy1 !== '0'
      && problemCategory2 !== '' && problemCategory2 !== '0'
      && copingStrategy2 !== '' && copingStrategy2 !== '0'
      && problemCategory3 !== '' && problemCategory3 !== '0'
      && copingStrategy3 !== '' && copingStrategy3 !== '0'
    ) {
      // console.log('you can register')
      /*
      Params for registerUser
              params.displayName,
              params.age,
              params.relationship,
              params.gender,
              params.state,
              params.livingSituation,
              params.studyField,
              params.problemCategory1,
              params.problemCategory2,
              params.problemCategory3,
              params.copingStrategy1,
              params.copingStrategy2,
              params.copingStrategy3,
              params.hobbyDescription,
              params.lossExperience
      
      */
      const d = new Date()
      const y = d.getFullYear()
      const age = Math.abs(y - birthYear).toString()
      const userObj = {
        "username": GH.removeWhiteSpace(email),
        "password": GH.removeWhiteSpace(password),
        "displayName": name,
        "age": age,
        "gender": sex,
        "state": location,
        "livingSituation": livingSituation,
        "studyField": studyField,
        "problemCategory1": problemCategory1,
        "problemCategory2": problemCategory2,
        "problemCategory3": problemCategory3,
        "copingStrategy1": copingStrategy1,
        "copingStrategy2": copingStrategy2,
        "copingStrategy3": copingStrategy3,
        "hobbyDescription": hobby,
        "lossExperience": story
      }
      // console.log(userObj)
      // updateSuccess(true)
      const result = await UserProfileHelper.registerUser(userObj)
      // console.log(result)

      if (!result) {
        return updateRegisterError(props.lang.registerError)
      }
      return updateSuccess(true)
    }
    return updateRegisterError(props.lang.informationMissing)
  }

  const handleSubmit = async (e) => {
    // e.preventDefault()
    if (e.key === 'Enter' || e.keyCode === 13) {
      await registerFunction()
      return
    }
  }

  if (!registerSuccessful) {
    return (<Grid
      container
      justifyContent={'center'}
      direction="column"
      rowSpacing={3}
      sx={{
        pb: 10,
      }}
    >
      <Grid item>
        <Paragraph align='center' variant="h4">{props.lang.register}</Paragraph>
      </Grid>
      <Grid item>
        <Tip>{props.lang.fillInformation}</Tip>
      </Grid>
      <form onKeyPress={handleSubmit}
        style={{
          width: "100%",
          flexDirection: 'column'
        }}
      >
        <TextInput
          id='match-username'
          type={"text"}
          label={props.lang.emailAddress}
          ariaLabel='email address'
          icon='envelope'
          withAdornment={false}
          placeholder={props.lang.yourEmail}
          error={emailValidated}
          onChange={e => {
            updateEmailValidated('')
            updateEmail(e.target.value)
          }}
        />

        <TextInput
          id='match-password'
          // ref={pass => this._password = pass}
          type={hidePass ? "password" : "text"}
          label={props.lang.passwordLabel}
          ariaLabel='password'
          icon='lock'
          endAdornmentIcon={hidePass ? "eye-slash" : "eye"}
          endAdornmentLabel={props.lang.togglePassVisibility}
          withAdornment={true}
          handleEndAdornmentClick={() => changeHide(!hidePass)}
          placeholder={props.lang.yourPassword}
          onChange={e => {
            updatePassword(e.target.value)
            const validate = AVH.validatePassword(e.target.value)
            if (typeof validate === 'object') {
              updatePassValidated(false)
              updateLowercase(validate.lowercase)
              updateCapital(validate.uppercase)
              updateNumber(validate.number)
              updateSpecial(validate.special)
              updateMinimum(validate.length)
            }
            else {
              updatePassValidated(true)
            }
            // console.log(validate)
          }}
        />
        {!passValidated ? <div className="pass-valid-section show">
          <div className="mx-auto col-sm-12">
            <Text className="pass-validation">{props.lang.passwordNotice}</Text>
            <Tip className={lowercase ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.lowercase}</Tip>
            <Tip className={capital ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.uppercase}</Tip>
            <Tip className={number ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.number}</Tip>
            <Tip className={special ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.specialChar}</Tip>
            <Tip className={minimum ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.eightChar}</Tip>
          </div>
        </div>
          : null}
        <TextInput
          id='match-displayname'
          // ref={pass => this._password = pass}
          type={"text"}
          label={props.lang.displaynameLabel}
          ariaLabel='display name'
          value={name}
          icon='user-alt'
          withAdornment={false}
          placeholder={props.lang.displaynamePlaceholder}
          error={nameError}
          onChange={e => {
            updateNameError('')
            updateName(e.target.value)
          }}
        />
        <TextInput
          id='match-birthyear'
          // ref={pass => this._password = pass}
          type={"number"}
          label={props.lang.birthLabel}
          ariaLabel='birth year'
          icon='calendar-alt'
          // value={birthYear}
          withAdornment={false}
          placeholder={props.lang.birthPlaceholder}
          error={birthError}
          onChange={e => {
            updateBirthError('')
            updateBirthYear(e.target.value)
          }}
        />
        <SelectItem
          options={studyFieldArr}
          id="match-studyField"
          label={props.lang.studyFieldLabel}
          name="studyField"
          inputValue={studyField}
          error={studyFieldError}
          handleInput={e => {
            updatestudyFieldError('')
            updatestudyField(e.target.value)
          }}
        />
        <SelectItem
          options={livingSituationArr}
          id="match-livingSituation"
          label={props.lang.livingsituationLabel}
          name="livingsituation"
          inputValue={livingSituation}
          error={livingSituationError}
          handleInput={e => {
            updatelivingSituationFieldError('')
            updateLivingSituation(e.target.value)
          }}
        />

        <SelectItem
          options={problemCategoryArr1}
          id="match-problemCategory1"
          label={props.lang.problemCategoryLabel}
          name="problemCategory1"
          inputValue={problemCategory1}
          error={problemCategoryError1}
          handleInput={e => {
            updateproblemCategoryError1('')
            updateProblemCategory1(e.target.value)
          }}
        />
        <SelectItem
          options={problemCategoryArr2}
          id="match-problemCategory2"
          label={props.lang.problemCategoryLabel2}
          name="problemCategory2"
          inputValue={problemCategory2}
          error={problemCategoryError2}
          handleInput={e => {
            updateproblemCategoryError2('')
            updateProblemCategory2(e.target.value)
          }}
        />
        <SelectItem
          options={problemCategoryArr3}
          id="match-problemCategory3"
          label={props.lang.problemCategoryLabel3}
          name="problemCategory3"
          inputValue={problemCategory3}
          error={problemCategoryError3}
          handleInput={e => {
            updateproblemCategoryError3('')
            updateProblemCategory3(e.target.value)
          }}
        />

        <SelectItem
          options={copingStrategyArr1}
          id="match-copingStrategy1"
          label={props.lang.copingStrategyLabel}
          name="copingStrategy"
          inputValue={copingStrategy1}
          error={copingStrategyError1}
          handleInput={e => {
            updatecopingStrategyError1('')
            updateCopingStrategy1(e.target.value)
          }}
        />
        <SelectItem
          options={copingStrategyArr2}
          id="match-copingStrategy2"
          label={props.lang.copingStrategyLabel2}
          name="copingStrategy2"
          inputValue={copingStrategy2}
          error={copingStrategyError2}
          handleInput={e => {
            updatecopingStrategyError2('')
            updateCopingStrategy2(e.target.value)
          }}
        />
        <SelectItem
          options={copingStrategyArr3}
          id="match-copingStrategy3"
          label={props.lang.copingStrategyLabel3}
          name="copingStrategy3"
          inputValue={copingStrategy3}
          error={copingStrategyError3}
          handleInput={e => {
            updatecopingStrategyError3('')
            updateCopingStrategy3(e.target.value)
          }}
        />


        {/* <SelectItem
          options={problemCategoryArr}
          id="match-problemCategory"
          label={props.lang.problemCategoryLabel}
          name="problemCategory"
          inputValue={problemCategory}
          error={problemCategoryError}
          handleInput={e => {
            updateproblemCategoryError('')
            updateProblemCategory(e.target.value)
          }}
        />
        <SelectItem
          options={copingStrategyArr}
          id="match-copingStrategy"
          label={props.lang.copingStrategy}
          name="copingStrategy"
          inputValue={copingStrategy}
          error={copingStrategyError}
          handleInput={e => {
            updatecopingStrategyError('')
            updateCopingStrategy(e.target.value)
          }}
        /> */}


        <SelectItem
          options={gender}
          id="match-gender"
          label={props.lang.genderLabel}
          name="gender"
          inputValue={sex}
          error={sexError}
          handleInput={e => {
            updateSexError('')
            updateSex(e.target.value)
          }}
        />
        <SelectItem
          options={states}
          id="match-states"
          label={props.lang.locationLabel}
          name="states"
          inputValue={location}
          error={locationError}
          handleInput={e => {
            updateLocationError('')
            updateLocation(e.target.value)
          }}
        />
        <TextArea
          type={"text"}
          label={props.lang.lossStoryLabel}
          placeholder={props.lang.lossStoryPlaceholder}
          ariaLabel='story'
          error={storyError}
          helperText={`${story.length}/750 ${props.lang.words}`}
          onChange={e => {
            // console.log(e.target.value.length)
            if (e.target.value.length > 750) {
              updateStoryError(`${props.lang.wordLimitWarning} ${story.length}/750 ${props.lang.words}`)
              updateStory(e.target.value)
              return
            }
            updateStoryError('')
            updateStory(e.target.value)
          }}
          rows={4}
        />
        <TextArea
          type={"text"}
          label={props.lang.hobbiesDescriptionLabel}
          placeholder={props.lang.hobbiesDescriptionPlaceholder}
          ariaLabel='hobby'
          error={hobbyError}
          helperText={`${hobby.length}/750 ${props.lang.words}`}
          onChange={e => {
            // console.log(e.target.value.length)
            if (e.target.value.length > 750) {
              updateHobbyError(`${props.lang.wordLimitWarning} ${hobby.length}/750 ${props.lang.words}`)
              updateHobby(e.target.value)
              return
            }
            updateHobbyError('')
            updateHobby(e.target.value)
          }}
          rows={4}
        />
        <Checkbox
          label={props.lang.disclaimer}
          checked={disclaimer}
          error={disclaimerError}
          onChange={() => {
            updateDisclaimerError('')
            checkDisclaimer(!disclaimer)
          }}
        />
        <Button tabIndex='0' fullWidth className='mx-auto mt-4' onClick={registerFunction}>{props.lang.submit}</Button>
      </form>

      {/*<Grid item>
          <form onKeyPress={handleSubmit}
            style={{
              flexDirection:'column'
            }}
          >


            <TextInput 
                id='match-password'
                // ref={pass => this._password = pass}
                type={hidePass ? "password" : "text"}
                label={props.lang.passwordLabel}
                ariaLabel='password'
                icon='lock'
                endAdornmentIcon={hidePass ? "eye-slash" : "eye"}
                endAdornmentLabel={props.lang.togglePassVisibility}
                withAdornment={true}
                handleEndAdornmentClick={() => changeHide(!hidePass)}
                placeholder={props.lang.yourPassword}
                onChange={e => {
                    updatePassword(e.target.value)
                    const validate = AVH.validatePassword(e.target.value)
                    if(typeof validate === 'object')
                    {
                        updatePassValidated(false)
                        updateLowercase(validate.lowercase)
                        updateCapital(validate.uppercase)
                        updateNumber(validate.number)
                        updateSpecial(validate.special)
                        updateMinimum(validate.length)
                    }
                    else
                    {
                        updatePassValidated(true)
                    }
                    // console.log(validate)
                }}
            />
            {!passValidated ? <div className="pass-valid-section show">
                <div className="mx-auto col-sm-12">
                    <Text className="pass-validation">{props.lang.passwordNotice}</Text>
                    <Tip className={lowercase ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.lowercase}</Tip>
                    <Tip className={capital ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.uppercase}</Tip>
                    <Tip className={number ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.number}</Tip>
                    <Tip className={special ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.specialChar}</Tip>
                    <Tip className={minimum ? "pass-validation valid" : "pass-validation invalid"}>{props.lang.passCriteria.eightChar}</Tip>
                </div>
            </div>
            :null}
            <TextInput 
              id='match-displayname'
              // ref={pass => this._password = pass}
              type={"text"}
              label={props.lang.displaynameLabel}
              ariaLabel='display name'
              value={name}
              icon='user-alt'
              withAdornment={false}
              placeholder={props.lang.displaynamePlaceholder}
              error={nameError}
              onChange={e => {
                updateNameError('')
                updateName(e.target.value)
              }}
            />
            <TextInput 
                id='match-birthyear'
                // ref={pass => this._password = pass}
                type={"number"}
                label={props.lang.birthLabel}
                ariaLabel='birth year'
                icon='calendar-alt'
                // value={birthYear}
                withAdornment={false}
                placeholder={props.lang.birthPlaceholder}
                error={birthError}
                onChange={e => {
                  updateBirthError('')
                  updateBirthYear(e.target.value)
                }}
            />
            <SelectItem 
                options={studyFieldArr}
                id="match-studyField"
                label={props.lang.studyFieldLabel}
                name="studyField"
                inputValue={studyField}
                error={studyFieldError}
                handleInput={e => {
                  updatestudyFieldError('')
                  updatestudyField(e.target.value)
                }}
            />
            <SelectItem 
                options={livingSituationArr}
                id="match-livingSituation"
                label={props.lang.livingsituationLabel}
                name="livingsituation"
                inputValue={livingSituation}
                error={livingSituationError}
                handleInput={e => {
                  updatelivingSituationFieldError('')
                  updateLivingSituation(e.target.value)
                }}
            />
            <SelectItem 
                options={problemCategoryArr}
                id="match-problemCategory"
                label={props.lang.problemCategoryLabel}
                name="problemCategory"
                inputValue={problemCategory}
                error={problemCategoryError}
                handleInput={e => {
                  updateproblemCategoryError('')
                  updateProblemCategory(e.target.value)
                }}
            />
            <SelectItem 
                options={copingStrategyArr}
                id="match-copingStrategy"
                label={props.lang.copingStrategy}
                name="copingStrategy"
                inputValue={copingStrategy}
                error={copingStrategyError}
                handleInput={e => {
                  updatecopingStrategyError('')
                  updateCopingStrategy(e.target.value)
                }}
            />
            <SelectItem 
                options={gender}
                id="match-gender"
                label={props.lang.genderLabel}
                name="gender"
                inputValue={sex}
                error={sexError}
                handleInput={e => {
                  updateSexError('')
                  updateSex(e.target.value)
                }}
            />
            <SelectItem 
                options={states}
                id="match-states"
                label={props.lang.locationLabel}
                name="states"
                inputValue={location}
                error={locationError}
                handleInput={e => {
                  updateLocationError('')
                  updateLocation(e.target.value)
                }}
            />
            <TextArea 
              type={"text"}
              label={props.lang.lossStoryLabel}
              placeholder={props.lang.lossStoryPlaceholder}
              ariaLabel='story'
              error={storyError}
              helperText={`${story.length}/750 ${props.lang.words}`}
              onChange={e => {
                // console.log(e.target.value.length)
                if(e.target.value.length > 750)
                {
                  updateStoryError(`${props.lang.wordLimitWarning} ${story.length}/750 ${props.lang.words}`)
                  updateStory(e.target.value)
                  return
                }
                updateStoryError('')
                updateStory(e.target.value)
              }}
              rows={4}
          />
          <TextArea 
              type={"text"}
              label={props.lang.hobbiesDescriptionLabel}
              placeholder={props.lang.hobbiesDescriptionPlaceholder}
              ariaLabel='hobby'
              error={hobbyError}
              helperText={`${hobby.length}/750 ${props.lang.words}`}
              onChange={e => {
                // console.log(e.target.value.length)
                if(e.target.value.length > 750)
                {
                  updateHobbyError(`${props.lang.wordLimitWarning} ${hobby.length}/750 ${props.lang.words}`)
                  updateHobby(e.target.value)
                  return
                }
                updateHobbyError('')
                updateHobby(e.target.value)
              }}
              rows={4}
          />
          <Checkbox 
              label={props.lang.disclaimer}
              checked={disclaimer}
              error={disclaimerError}
              onChange={() => {
                updateDisclaimerError('')
                checkDisclaimer(!disclaimer)
              }}
          />
          <Button tabIndex='0' fullWidth className='mx-auto mt-4' onClick={registerFunction}>{props.lang.submit}</Button>
          </form>
            </Grid>*/}

      <Grid item>

        <Grid item xs id='match-register-form'
          sx={{
            mx: 'auto'
          }}
        >
          {registerError !== '' ? <Alert severity="error"><Text className='fyw-font-dark mx-auto'>{`Error display ${registerError}`}</Text></Alert>: null}
        </Grid>
        <Grid className='mx-auto d-flex justify-content-center flex-column'>
          <Text className='fyw-font-dark mx-auto'>{props.lang.joined}
            <span className='href-link ml-2 fyw-font-bold' tabIndex="0" aria-label='join now' role='link' onClick={() => {
              props.switchToLogin(true)
            }}>{props.lang.loginNow}</span>
          </Text>
        </Grid>
      </Grid>

    </Grid>)
  }
  return <React.Fragment>
    <Grid item xs={12} sm={10} md={8} className='mx-auto'>
      <Grid className='mx-auto text-center'>
        <Paragraph className='fyw-font-dark fyw-font-bold my-5'>{props.lang.complete}</Paragraph>
        <Paragraph className='fyw-font-grey'>{props.lang.thankYou}</Paragraph>
        <Button className='fyw-btn-dark mx-auto' onClick={() => {
          props.switchToLogin(true)
        }}>{props.lang.backToLogin}</Button>
      </Grid>
    </Grid>
  </React.Fragment>
}


export default Register
